(function () {
    'use strict';

    angular
        .module('ActionManager')
        .factory('action-rms-load-enum', actionFunc);

    function actionFunc(RmsEnum, $q) {
        return function(options) {
            return $q.all(options.enums.map(function(enumName) {
                return RmsEnum.load(enumName);
            }));
        };
    }
})();